import { Routes } from '@angular/router';
import { policyRoutes } from './policy.routes';

const loginRoute = {
    path: 'login',
    loadChildren: () =>
        import('../pages/login/login.routes').then(m => m.loginRoutes),
};

const registerRoute = {
    path: 'register',
    loadChildren: () =>
        import('../pages/register/register.routes').then(m => m.registerRoutes),
};

const forgotPasswordRoute = {
    path: 'forgot-password',
    loadChildren: () =>
        import('../pages/forgot-password/forgot-password.routes').then(
            m => m.forgotPasswordRoutes
        ),
};

const resetPasswordRoute = {
    path: 'reset-password',
    loadChildren: () =>
        import('../pages/reset-password/reset-password.routes').then(
            m => m.resetPassowrdRoutes
        ),
};

export const publicRoutes: Routes = [
    loginRoute,
    registerRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
    ...policyRoutes,
    { path: '**', redirectTo: '/login' },
];